import { Banner } from "algoliasearch-helper";
import Link from "next/link";

import imageUtils from "~/utils/image-utils";

import NextImage from "../common/next-image";
import styles from "./algolia-banner.module.scss";

type Props = {
  banner: Banner;
};

export default function AlgoliaBanner(props: Props) {
  return (
    <div className={styles.container}>
      {props.banner.link ? (
        <Link href={props.banner.link.url} target={props.banner.link.target} className={styles.link}>
          <NextImage
            className={styles.image}
            src={props.banner.image.urls[0].url}
            alt={props.banner.image.title ?? ""}
            fill
            loader={imageUtils.contentfulImageLoader}
          />
        </Link>
      ) : (
        <NextImage
          className={styles.image}
          src={props.banner.image.urls[0].url}
          alt={props.banner.image.title ?? ""}
          fill
          loader={imageUtils.contentfulImageLoader}
        />
      )}
    </div>
  );
}
